export default [
    {
      path: "seller-fees",
      name: "seller-fees",
      component: () => import("@/views/seller-fees/Index"),
      meta: {
        nextable: true,
      },
    },
  ];